// A small curated palette (not the reserved accent/success/error colors) so letter avatars
// add visual variety without competing with semantic UI colors.
const PALETTE = ['#5b6472', '#3f5875', '#5c6f4f', '#7a5c8a', '#8a5c5c', '#4f7a7a', '#7a6a4f'];

/** Deterministic color for a label, so the same brand/model always gets the same avatar color. */
export function labelToColor(label: string): string {
  let hash = 0;
  for (let i = 0; i < label.length; i++) {
    hash = (hash * 31 + label.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}
